(function($) {
    $(function() {
        const theForm = $('.js-poll-form');

        if(!theForm.length){
            return;
        }
        
        let blockSubmitTwice = false;

        theForm.submit(function() {

            if (!$("input[name='poll-answer']:checked").val()) {
                swal({
                    title: 'Ön még nem szavazott!',
                    icon: 'error',
                    button: 'Bezárom'
                });
            } else {

                if (blockSubmitTwice) {
                    return;
                }

                blockSubmitTwice = true;

                const pollId = theForm.data('poll-id');
                const answerId = $("input[name='poll-answer']:checked").data('answerid');

                apiGetCall('poll/submit', { 'pollid': pollId, 'answerid': answerId }, function(error, result) {
                    blockSubmitTwice = false;

                    if (error) {
                        return swal({
                            title: 'HIBAÜZENET:',
                            text: error,
                            icon: 'error',
                            button: 'Bezárom'
                        });
                    }

                    if(result.success){
                        $('.js-poll-form').addClass("d-none");
                        $('.js-success-form-submit').removeClass("d-none");
                        $('html,body').animate({ scrollTop: 0 });
                    }
                });
            }

            return false;
        });
    });
})(jQuery);